import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../../components/headerCard";
import { LocatorDTO } from "../../../../dtos/LocatorDTO";
import { useEffect, useRef, useState } from "react";
import { useListLocator } from "../hooks/useListLocator";
import { useDeleteLocator } from "../hooks/useDeleteLocator";
import { RiCloseFill, RiPencilFill } from "react-icons/ri";

export function ListLocator() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [locatorInfo, setLocatorInfo] = useState<LocatorDTO>({} as LocatorDTO);

  const { getLocator, isLoading, data } = useListLocator();
  const { deleteLocator, loadingDelete } = useDeleteLocator();

  const cancelRef = useRef<any>(null);

  async function deleteLocatorData(id: string) {
    try {
      await deleteLocator(id);

      toast({
        position: "top-right",
        title: "Motorista",
        description: "Locador removido com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top-right",
        title: "Motorista",
        description: "Não foi possível remover o Locador.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      onClose();
      setLocatorInfo({} as LocatorDTO);
      getLocator();
    }
  }

  useEffect(() => {
    getLocator();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <HeaderCard
        title="LOCADORES"
        titleButton="Novo Locador"
        link="/locadores/novo"
      />

      {isLoading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {data.length > 0 && !isLoading && (
          <Box p="4" borderRadius={8} height={500}>
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th color="white" textAlign="center">
                      TIPO REGISTRO
                    </Th>
                    <Th color="white" textAlign="center">
                      N DO REGISTRO
                    </Th>
                    <Th color="white" textAlign="center">
                      NOME
                    </Th>
                    <Th color="white" textAlign="center">
                      ENDEREÇO
                    </Th>
                    <Th color="white" textAlign="center">
                      MUNICÍPIO/UF
                    </Th>
                    <Th color="white" textAlign="center">
                      TELEFONE
                    </Th>
                    <Th color="white" textAlign="center">
                      AÇÕES
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <Td textAlign="center">{item.type_registry}</Td>
                      <Td textAlign="center">{item.registration_number}</Td>
                      <Td textAlign="center">{item.name}</Td>
                      <Td textAlign="center">{item.public_place}</Td>
                      <Td textAlign="center">
                        {item.city}/{item.state}
                      </Td>
                      <Td textAlign="center">{item.phone}</Td>
                      <Td textAlign="center" width="10">
                        <Button
                          size="sm"
                          fontSize="sm"
                          as="a"
                          href={`/locadores/atualizar/${item.id}`}
                        >
                          <Icon fontSize="16px" as={RiPencilFill} />
                        </Button>
                        <Button
                          size="sm"
                          ml={1}
                          fontSize="sm"
                          onClick={() => {
                            setLocatorInfo(item);
                            onOpen();
                          }}
                        >
                          <Icon fontSize="16px" as={RiCloseFill} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover Locador
            </AlertDialogHeader>

            <AlertDialogBody>
              {!loadingDelete && (
                <Text>
                  Deseja remover o locador: <strong>{locatorInfo?.name}</strong>
                </Text>
              )}

              {loadingDelete && (
                <Flex width="100%" alignItems="center" justifyContent="center">
                  <Spinner
                    color="green.600"
                    emptyColor="white"
                    thickness="4px"
                    size="xl"
                    h={50}
                    w={50}
                  />
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              {!loadingDelete && (
                <>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteLocatorData(locatorInfo?.id);
                    }}
                  >
                    Sim
                  </Button>
                  <Button ml={3} onClick={onClose}>
                    Nāo
                  </Button>
                </>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
